'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});
exports.default = void 0;
var _react = _interopRequireDefault(require('react'));
var _base = require('@atlaskit/icon/base');
function _interopRequireDefault(e) {
	return e && e.__esModule ? e : { default: e };
}
const Generic24Icon = (props) =>
	/*#__PURE__*/ _react.default.createElement(
		_base.IconFacade,
		Object.assign(
			{
				dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
			},
			props,
			{
				size: 'medium',
			},
		),
	);
Generic24Icon.displayName = 'Generic24Icon';
var _default = (exports.default = Generic24Icon);
